import { getFilterParams } from '~/dashboards/filters/utils'
import { currencyCodeToSymbol } from '~/common/currencyUtils'
import { useMsg } from '~/common/localizationUtils'
import { useLocalizeHelpers } from '~/common/dateUtils'
import { getHumanReadableFloat } from '~/common/numberUtils'
import { LineChart } from '~/design_system'
import { ChartCard } from '~/dashboards/ChartCard'

/** Convert total to currency display format */
export const toDisplayCurrency = value => {
  const currencySymbol = currencyCodeToSymbol('USD') // currencyCode is hardcoded
  const number = getHumanReadableFloat(value).join('')
  return `${currencySymbol}${number}`
}

/**
 * Renders a responsive line chart from the provided payments data.
 * Automatically adapts to the size of its container.
 */
export const PaymentsChart = ({ queryId, filters = [], filterAdapters = {}, ...rest }) => {
  const queryFilters = getFilterParams(filters, filterAdapters)
  const msg = useMsg()
  const { monthYear: monthYearFormatter } = useLocalizeHelpers()
  return (
    <ChartCard
      queryId={queryId}
      reportKey="payments_by_month"
      filters={queryFilters}
      chart={LineChart}
      chartConfig={{
        format: 'currency',
        xAxisLabel: msg('dashboards.chart.payments_by_month.x_axis_label'),
        yAxisLabel: msg('dashboards.chart.payments_by_month.y_axis_label'),
        title: msg('term.payments', { count: 99 }),
        xAxisFormat: date => monthYearFormatter(date),
        yAxisFormat: toDisplayCurrency
      }}
      {...rest}
    />
  )
}
